import { z } from 'zod';
import { defineFeature } from '../core/defineFeature.js';
import { FeatureType } from '../core/types.js';
const Visualizations = { id: 9, name: 'Visualizations' };
export const availableWidgets = defineFeature({
    type: FeatureType.MultiSelect,
    propName: 'available_widgets',
    uiName: 'availableWidgets',
    displayName: 'Available Widgets',
    description: 'Widgets the agent has access to to visualize data',
    category: Visualizations,
    areas: ['agent'],
    codec: 'identity',
    schema: z.array(z.string()),
    default: [],
    validValues: [
        'kpi-card',
        'stacked-bar',
        'bar',
        'line',
        'multiple-line',
        'multiple-clustered-bar',
        'multiple-stacked-bar',
        'pie',
    ],
    options: {
        'kpi-card': { displayName: 'KPI Card' },
        'stacked-bar': { displayName: 'Stacked Bar Chart' },
        bar: { displayName: 'Bar Chart' },
        line: { displayName: 'Line Chart' },
        'multiple-line': { displayName: 'Multiple Line Chart' },
        'multiple-clustered-bar': { displayName: 'Multiple Clustered Bar Chart' },
        'multiple-stacked-bar': { displayName: 'Multiple Stacked Bar Chart' },
        pie: { displayName: 'Pie Chart' },
    },
    isSystem: true,
    surfacedIn: ['agent'],
});
export const tableHcpViewProfileLinks = defineFeature({
    type: FeatureType.Json,
    propName: 'table_hcp_view_profile_links',
    uiName: 'tableHcpViewProfileLinks',
    displayName: 'Table - HCP View Profile Links',
    description: 'Configure profile link behavior for HCP table rows in agent responses',
    category: Visualizations,
    areas: ['agent'],
    codec: 'identity',
    schema: z.object({
        enabled: z.boolean(),
    }),
    default: {
        enabled: false,
    },
    isSystem: true,
    surfacedIn: ['agent'],
    editor: 'table-profile-links-config',
});
export const tableAccountViewProfileLinks = defineFeature({
    type: FeatureType.Json,
    propName: 'table_account_view_profile_links',
    uiName: 'tableAccountViewProfileLinks',
    displayName: 'Table - Account View Profile Links',
    description: 'Configure profile link behavior for account table rows in agent responses',
    category: Visualizations,
    areas: ['agent'],
    codec: 'identity',
    schema: z.object({
        enabled: z.boolean(),
    }),
    default: {
        enabled: false,
    },
    isSystem: true,
    surfacedIn: ['agent'],
    editor: 'table-profile-links-config',
});
export const visualizationsFeatures = [
    availableWidgets,
    tableHcpViewProfileLinks,
    tableAccountViewProfileLinks,
];
